/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type KeycloakRealm = 'SprintMemberApp' | 'SprintExpertApp' | 'SprintExpertManagerApp' | 'SprintBackofficeApp';

export const KeycloakRealm = {
    SprintMemberApp: 'SprintMemberApp' as KeycloakRealm,
    SprintExpertApp: 'SprintExpertApp' as KeycloakRealm,
    SprintExpertManagerApp: 'SprintExpertManagerApp' as KeycloakRealm,
    SprintBackofficeApp: 'SprintBackofficeApp' as KeycloakRealm
};

